import axios from 'axios';
import { baseUrl } from '@/config';
import { forEach, isEmpty } from 'lodash';

export default {
  /**
   * [설정 > 사용자관리] 사용자 설정 화면의 사용자 정보 리스트를 조회한다.
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getUserList(params) {
    return axios.post(`${baseUrl}/settings/user/get-user-list.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 설정 화면의 비활성화 사용자 정보를 업데이트한다.
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   */
  updateUserList(params) {
    return axios.post(`${baseUrl}/settings/user/update-user-list.do`, params);
  },
  /**
   * [설정 > 사용자관리] 계정 활성/비활성과 계정 잠금 정보를 업데이트 한다.
   * @author yelim
   */
  updateMgrInfo(params) {
    return axios.post(`${baseUrl}/settings/user/update-mgr-info.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 추가/수정 팝업의 비밀번호 validation 체크를 위한 계정정책 리스트를 조회한다.
   * @author najongdang
   * @return {Map} 계정정책정보
   */
  getAllAccountPolicyList() {
    return axios.get(`${baseUrl}/settings/user/get-all-account-policy-list.do`);
  },

  /**
   * [설정 > 사용자관리] 사용자 추가/수정 팝업의 아이디 validation 체크.
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  checkIdValidation(params) {
    return axios.post(`${baseUrl}/settings/user/check-id-validation.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 추가 팝업의 사용자 정보 추가
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  insertUserInfo(params) {
    return axios.post(`${baseUrl}/settings/user/insert-user-info.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 추가 팝업의 사용자 정보 수정
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  updateUserInfo(params) {
    return axios.post(`${baseUrl}/settings/user/update-user-info.do`, params);
  },

  /**
   * [설정 > 사용자관리] 관리자 패스워드 확인.
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  checkAdminPassword(params) {
    return axios.post(`${baseUrl}/settings/user/check-admin-password.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 패스워드 변경
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  changePassword(params) {
    return axios.post(`${baseUrl}/settings/user/change-password.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 패스워드 초기화
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  initPassword(params) {
    return axios.post(`${baseUrl}/settings/user/init-password.do`, params);
  },

  /**
   * [설정 > 사용자관리] 사용자 추가/수정 팝업에서 장비 권한 정보를 조회한다.
   * @author najongdang
   * @param  {Object} params mgr 테이블 정보
   * @return {[type]}        [description]
   */
  getDeviceAuthInfo(managerId) {
    return axios.get(`${baseUrl}/settings/user/get-device-auth-info.do`, { params: { managerId } });
  },
  /**
   * [설정 > 사용자관리] 사용자 설정 화면의 선택한 특정 사용자 정보를 조회한다
   * @author jeee12
   * @param  {[type]} params managerId
   * @return {[type]}        [description]
   */
  getUserInfo(params) {
    return axios.post(`${baseUrl}/settings/user/get-user-info.do`, params);
  },
  /**
   * 설정 > 초기 설정 > 사용자 설정 > 사용자 엑셀 출력
   * @author Song
   * @return {[type]}        [description]
   */
  exportUserList(params) {
    return axios.post(`${baseUrl}/settings/user/export-user-list.do`, params);
  },
  /**
   * 설정 > 초기 설정 > 사용자 설정 > 사용자 엑셀 입력
   * @author Song
   * @return {[type]}   [description]
   */
  importUserList(params) {
    return axios.post(`${baseUrl}/settings/user/import-user-list.do`, params);
  },
  /**
   * [설정 > 사용자관리] 장비 권한 설정
   * @author najongdang
   * @param  {Object} params UserParamVO
   * @return {[type]}        [description]
   */
  setMgrObj(params) {
    return axios.post(`${baseUrl}/settings/user/set-mgr-obj.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/user/user-setting.js